import axios from 'axios'
// import store from '../store/store'
import 'regenerator-runtime/runtime'

export default async () => {
  let url
  if (process.env.NODE_ENV === 'prodlocal') {
    const addr = `public/config.json?nocache=${Date.now()}`
    const response = await axios.get(addr)
    const env = response.data
    url = `${env.SERVER_SSL_FLAG === 'true' ? 'https' : 'http'}://${env.SERVER_HOST_NAME}:${env.SERVER_PORT}/`
  } else {
    url = `${process.env.VUE_APP_SERVER_SSL_FLAG === 'true' ? 'https' : 'http'}://${
      process.env.VUE_APP_SERVER_HOST_NAME
    }:${process.env.VUE_APP_SERVER_PORT}/`
  }
  return axios.create({
    withCredentials: true,
    baseURL: url,
    // headers: {
    // Authorization: `Bearer ${store.state.token}`,
    // },
  })
}
